export default function DeliveryCard({ delivery, provided, onClick, onPrepChange, onReportToggle, livreurColors = {} }) {

    const livreurIri = delivery.livreur?.['@id'] || (delivery.livreur?.id ? `/api/users/${delivery.livreur.id}` : null);
    const livreurColor = livreurColors[livreurIri];
    const statutPatient = delivery.patient?.statutPatient;
    const isPause = statutPatient === 'en_pause';
    const isHospitalise = statutPatient === 'hospitalise';
    const isAttenued = isPause || isHospitalise;

    const statutPrepStyles = {
        'a_contacter': { bg: '#fef3c7', color: '#d97706', label: '📞 À contacter' },
        'en_attente':  { bg: '#fff7ed', color: '#ea580c', label: '💬 En attente' },
        'confirme':    { bg: '#dbeafe', color: '#2563eb', label: '✅ Confirmé' },
        'prepare':     { bg: '#dcfce7', color: '#16a34a', label: '📦 Préparé' },
        'annule':      { bg: '#fee2e2', color: '#dc2626', label: '❌ Annulé' },
    };

    const pathologieColors = {
        'nutrition':  '#16a34a',
        'perfusion':  '#2563eb',
        'parkinson':  '#1a1a2e',
    };

    const pathologieColor = isAttenued
        ? '#b0b8c1'
        : (pathologieColors[delivery.patient?.pathologie] || '#1a1a2e');

    const typeBorderColors = {
        'standard':       null,
        'recup':          '#f59e0b',
        'installation':   '#ef4444',
        'envoi_tnt':      '#8b5cf6',
        'envoi_postal':   '#06b6d4',
        'visite_patient': '#10b981',
    };

    const typeBorder = typeBorderColors[delivery.typelivraison];
    const secteurNom = delivery.patient?.secteur?.nom;
    const prep = statutPrepStyles[delivery.statutPrep] || statutPrepStyles['a_contacter'];
    const isRetro = delivery.patient?.isRetro;

    const alerteKeyframes = `
        @keyframes haloAlerte {
            0%   { box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.7); }
            70%  { box-shadow: 0 0 0 10px rgba(239, 68, 68, 0); }
            100% { box-shadow: 0 0 0 0 rgba(239, 68, 68, 0); }
        }`;

    if (!document.getElementById('alerte-style')) {
        const style = document.createElement('style');
        style.id = 'alerte-style';
        style.textContent = alerteKeyframes;
        document.head.appendChild(style);
    }

    const handlePrepClick = (e) => {
        e.stopPropagation();
        const order = ['a_contacter', 'en_attente', 'confirme', 'prepare', 'annule'];
        const current = delivery.statutPrep || 'a_contacter';
        const next = order[(order.indexOf(current) + 1) % order.length];
        onPrepChange && onPrepChange(next);
    };

    const handleReportClick = (e) => {
        e.stopPropagation();
        onReportToggle && onReportToggle(!delivery.reportPending);
    };

    const chuColors = {
        'nancy':       { bg: '#fef9c3', border: '#eab308' },
        'epinal':      { bg: '#dbeafe', border: '#3b82f6' },
        'bar_le_duc':  { bg: '#dcfce7', border: '#22c55e' },
        'neufchateau': { bg: '#fee2e2', border: '#ef4444' },
    };
    const chu = delivery.patient?.chu;
    const chuStyle = chuColors[chu] || { bg: '#fef3c7', border: '#f59e0b' };

    const cardBg = isHospitalise
        ? '#fef2f2'
        : isPause
            ? '#f8fafc'
            : 'white';

    return (
        <div style={{ position: 'relative', marginBottom: '4px' }}>

            {/* Badge croix médicale — hospitalisé */}
            {isHospitalise && (
                <div
                    title="Patient hospitalisé"
                    style={{
                        position: 'absolute',
                        top: '-6px',
                        left: '-6px',
                        width: '18px',
                        height: '18px',
                        borderRadius: '50%',
                        backgroundColor: '#fee2e2',
                        border: '2px solid #ef4444',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 10,
                    }}
                >
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="3.5" y="0" width="3" height="10" rx="0.8" fill="#ef4444"/>
                        <rect x="0" y="3.5" width="10" height="3" rx="0.8" fill="#ef4444"/>
                    </svg>
                </div>
            )}

            {/* Badge pause */}
            {isPause && (
                <div
                    title="Patient en pause"
                    style={{
                        position: 'absolute',
                        top: '-6px',
                        left: '-6px',
                        width: '18px',
                        height: '18px',
                        borderRadius: '50%',
                        backgroundColor: '#f1f5f9',
                        border: '2px solid #94a3b8',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '9px',
                        zIndex: 10,
                    }}
                >⏸</div>
            )}

            {/* Badge compte rendu */}
            {delivery.reportPending && (
                <div
                    onClick={handleReportClick}
                    title="Compte rendu à faire — cliquer pour marquer comme fait"
                    style={{
                        position: 'absolute',
                        top: '-6px',
                        left: isAttenued ? '16px' : '-6px',
                        width: '18px',
                        height: '18px',
                        borderRadius: '50%',
                        backgroundColor: '#fef3c7',
                        border: '2px solid #f59e0b',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '9px',
                        zIndex: 10,
                        cursor: 'pointer',
                    }}
                >📋</div>
            )}

            {/* Badge imuno */}
            {delivery.imuno && (
                <div title={`Immunosuppresseur — CHU ${chu || 'non défini'}`} style={{
                    position: 'absolute',
                    top: '-6px',
                    right: '-6px',
                    width: '18px',
                    height: '18px',
                    borderRadius: '50%',
                    backgroundColor: chuStyle.bg,
                    border: `2px solid ${chuStyle.border}`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '10px',
                    zIndex: 10,
                    filter: isAttenued ? 'grayscale(1)' : 'none',
                }}>⭐</div>
            )}

            <div
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                onClick={onClick}
                style={{
                    ...provided.draggableProps.style,
                    backgroundColor: cardBg,
                    borderRadius: '6px',
                    padding: '6px 10px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                    border: typeBorder ? `2px solid ${typeBorder}` : '2px solid transparent',
                    borderLeft: isHospitalise
                        ? '3px solid #ef4444'
                        : isPause
                            ? '3px solid #94a3b8'
                            : typeBorder
                                ? `4px solid ${typeBorder}`
                                : `3px solid ${pathologieColor}`,
                    cursor: 'pointer',
                    opacity: isAttenued ? 0.75 : 1,
                    outline: delivery.reportPending ? '1px solid #fbbf24' : 'none',
                    animation: delivery.alerte ? 'haloAlerte 1.5s ease-in-out infinite' : 'none',
                    outlineOffset: '1px',
                }}
            >
                <div style={{display: 'flex', gap: '6px'}}>
                    {/* Colonne gauche : checkbox + molécule empilés */}
                    <div style={{display: 'flex', flexDirection: 'column', gap: '3px', flexShrink: 0}}>
                        <div
                            onClick={handlePrepClick}
                            title={prep.label}
                            style={{
                                width: '16px',
                                height: '16px',
                                borderRadius: '4px',
                                backgroundColor: isAttenued ? '#f1f5f9' : prep.bg,
                                color: isAttenued ? '#94a3b8' : prep.color,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '9px',
                                fontWeight: delivery.statutPrep === 'prepare' ? '900' : '400',
                                cursor: 'pointer',
                                border: `1px solid ${isAttenued ? '#cbd5e1' : prep.color}`,
                            }}
                        >
                            {delivery.statutPrep === 'a_contacter' ? '?' :
                                delivery.statutPrep === 'en_attente' ? '💬' :
                                    delivery.statutPrep === 'confirme' ? '●' :
                                        delivery.statutPrep === 'prepare' ? '✓' : '✕'}
                        </div>

                        {delivery.imuno && delivery.patient?.molecule && (
                            <div
                                title={`Molécule : ${delivery.patient.molecule}`}
                                style={{
                                    width: '16px',
                                    height: '16px',
                                    borderRadius: '4px',
                                    backgroundColor: isAttenued ? '#e2e8f0' : chuStyle.bg,
                                    color: isAttenued ? '#94a3b8' : chuStyle.border,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '8px',
                                    fontWeight: '700',
                                    border: `1px solid ${isAttenued ? '#cbd5e1' : chuStyle.border}`,
                                }}
                            >
                                {delivery.patient.molecule}
                            </div>
                        )}
                    </div>

                    {/* Colonne droite : nom/livreur en haut, consigne/notes/secteur/CR en bas */}
                    <div style={{flex: 1, minWidth: 0}}>
                        {/* Ligne 1 : nom patient + livreur */}
                        <div style={{display: 'flex', alignItems: 'center', gap: '6px'}}>
                            <div style={{
                                flex: 1,
                                fontSize: '13px',
                                fontWeight: '600',
                                color: isRetro ? '#dc2626' : pathologieColor,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                            }}>
                                {delivery.patient?.nom}
                                {delivery.patient?.ville && (
                                    <span style={{
                                        fontWeight: '400',
                                        color: isAttenued ? '#b0b8c1' : '#aaa',
                                        fontSize: '11px'
                                    }}>{' '}({delivery.adresseSecondaireChoisie && delivery.patient?.villeSecondaire
                                        ? delivery.patient.villeSecondaire
                                        : delivery.patient.ville})</span>
                                )}
                            </div>

                            {delivery.livreur?.nom && (
                                <span style={{
                                    fontSize: '11px',
                                    fontWeight: '700',
                                    color: isAttenued ? '#94a3b8' : (livreurColor ? 'white' : 'var(--accent-color)'),
                                    backgroundColor: isAttenued ? '#e2e8f0' : (livreurColor || '#ede9fe'),
                                    padding: '2px 7px',
                                    borderRadius: '4px',
                                    flexShrink: 0,
                                }}>{delivery.livreur.nom.split(' ')[0]}</span>
                            )}
                            {delivery.livreur2?.nom && (
                                <span style={{
                                    fontSize: '11px',
                                    fontWeight: '700',
                                    color: 'white',
                                    backgroundColor: '#f59e0b',
                                    padding: '2px 7px',
                                    borderRadius: '4px',
                                    flexShrink: 0,
                                }}>{delivery.livreur2.nom.split(' ')[0].substring(0, 3)}</span>
                            )}
                        </div>

                        {/* Ligne 2 : consigne + notes + secteur + bouton CR */}
                        <div style={{display: 'flex', alignItems: 'center', gap: '6px', marginTop: '4px'}}>
                            {delivery.consigneHoraire && (
                                <span
                                    title={`Consigne horaire : ${delivery.consigneHoraire}`}
                                    style={{
                                        fontSize: '10px',
                                        fontWeight: '600',
                                        color: isAttenued ? '#c0c8d0' : '#d97706',
                                        backgroundColor: isAttenued ? '#e2e8f0' : '#fef3c7',
                                        padding: '1px 5px',
                                        borderRadius: '4px',
                                        flexShrink: 0,
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        maxWidth: '90px',
                                    }}
                                >⏰ {delivery.consigneHoraire}</span>
                            )}
                            {delivery.notes && (
                                <span style={{
                                    fontSize: '11px',
                                    color: isAttenued ? '#b0b8c1' : '#888',
                                    fontStyle: 'italic',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    flex: 1,
                                }}>{delivery.notes}</span>
                            )}
                            {!delivery.notes && <span style={{flex: 1}}/>}
                            {secteurNom && (
                                <span style={{
                                    fontSize: '9px',
                                    fontWeight: '600',
                                    color: isAttenued ? '#c0c8d0' : '#bbb',
                                    flexShrink: 0
                                }}>
                    {secteurNom.substring(0, 3).toUpperCase()}
                </span>
                            )}

                            {/* Bouton CR discret */}
                            <div
                                onClick={handleReportClick}
                                title={delivery.reportPending ? 'Compte rendu à faire — marquer comme fait' : 'Marquer : compte rendu à faire'}
                                style={{
                                    width: '14px',
                                    height: '14px',
                                    borderRadius: '3px',
                                    backgroundColor: delivery.reportPending ? '#fef3c7' : 'transparent',
                                    border: delivery.reportPending ? '1px solid #f59e0b' : '1px solid #e5e7eb',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '8px',
                                    flexShrink: 0,
                                    cursor: 'pointer',
                                    color: delivery.reportPending ? '#d97706' : '#d1d5db',
                                    transition: 'all 0.15s',
                                }}
                            >📋
                            </div>
                        </div>
                    </div>
            </div>
        </div>
</div>
)
    ;
}